import { supabase } from '../lib/supabase';

export async function listProjects() {
  const { data, error } = await supabase.from('projects').select('*').order('updated_at', { ascending: false });
  if (error) throw error;
  return data;
}

export async function createProject(input: { name: string; description?: string; mode?: string; center_latitude?: number; center_longitude?: number }) {
  const { data, error } = await supabase.rpc('create_project', { project_name: input.name, project_description: input.description, project_mode: input.mode, latitude: input.center_latitude, longitude: input.center_longitude });
  if (error) throw error;
  return data;
}
